<template>
  <svg
    :width="size * 1.54"
    :height="size"
    viewBox="0 0 37 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.58853 14.6199V15.9999H9.88053V14.6199H8.22453V8.04394H6.73653L4.54053 8.94394L4.94853 10.1559L6.50853 9.51994V14.6199H4.58853Z"
      :fill="color"
    />
    <path d="M12.6785 15.9999V14.1759H10.9145V15.9999H12.6785Z" :fill="color" />
    <path
      d="M13.8734 15.9999H19.6094L19.7414 14.4999H15.8414C16.7174 12.7479 19.5974 12.4599 19.5974 10.1199C19.5974 8.73994 18.8054 7.88794 16.9094 7.88794C14.9174 7.88794 13.8614 8.90794 14.0174 10.7079H15.7214C15.6494 9.77194 16.0214 9.24394 16.8014 9.24394C17.5694 9.24394 17.8334 9.68794 17.8334 10.2759C17.8334 11.8839 15.1934 12.0399 13.8734 14.6319V15.9999Z"
      :fill="color"
    />
    <path
      d="M20.9271 12.5079C21.2151 12.4599 22.0671 12.4239 22.6191 12.4239C24.0591 12.4239 24.7551 12.7359 24.7551 13.6599C24.7551 14.4519 24.3111 14.8599 23.5191 14.8599C22.6911 14.8599 22.3071 14.4759 22.3911 13.6839H20.6631C20.3991 15.3639 21.2511 16.1559 23.3751 16.1559C25.5351 16.1559 26.5191 15.1239 26.5191 13.5279C26.5191 11.7879 25.4151 11.1399 23.3031 11.1399C23.0511 11.1399 22.7751 11.1519 22.5231 11.1639L22.6551 9.54394H25.9671L26.0991 8.04394H21.2151L20.9271 12.5079Z"
      :fill="color"
    />
    <path
      d="M32.6496 9.90394H30.9096C30.7056 10.3239 30.5496 10.6719 30.4296 10.9719C30.2016 11.5119 30.0696 11.8839 29.9976 12.0879H29.9736C29.8776 11.7999 29.7336 11.4399 29.4576 10.8879L28.8816 9.80794L27.0816 9.91594L28.6296 12.8919L26.9496 15.9999H28.7016C28.9416 15.5319 29.0736 15.2199 29.2776 14.8119C29.5296 14.2479 29.7216 13.8039 29.7696 13.6239H29.8056C29.8776 13.8639 29.9976 14.1999 30.3816 14.9319L31.0176 16.1079L32.8176 15.9999L31.1496 12.7959L32.6496 9.90394Z"
      :fill="color"
    />
    <mask id="path-2-inside-1" fill="transparent">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z"
      />
    </mask>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z"
      :fill="color"
    />
    <path
      d="M12 2.6H25V0H12V2.6ZM2.6 12C2.6 6.80852 6.80852 2.6 12 2.6V0C5.37258 0 0 5.37258 0 12H2.6ZM12 21.4C6.80852 21.4 2.6 17.1915 2.6 12H0C0 18.6274 5.37258 24 12 24V21.4ZM25 21.4H12V24H25V21.4ZM34.4 12C34.4 17.1915 30.1915 21.4 25 21.4V24C31.6274 24 37 18.6274 37 12H34.4ZM25 2.6C30.1915 2.6 34.4 6.80852 34.4 12H37C37 5.37258 31.6274 0 25 0V2.6ZM1.3 12C1.3 6.09055 6.09055 1.3 12 1.3V-1.3C4.65461 -1.3 -1.3 4.65461 -1.3 12H1.3ZM12 22.7C6.09055 22.7 1.3 17.9094 1.3 12H-1.3C-1.3 19.3454 4.65461 25.3 12 25.3V22.7ZM25 22.7H12V25.3H25V22.7ZM35.7 12C35.7 17.9094 30.9094 22.7 25 22.7V25.3C32.3454 25.3 38.3 19.3454 38.3 12H35.7ZM25 1.3C30.9094 1.3 35.7 6.09055 35.7 12H38.3C38.3 4.65461 32.3454 -1.3 25 -1.3V1.3ZM12 1.3H25V-1.3H12V1.3Z"
      :fill="color"
      mask="url(#path-2-inside-1)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
